"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptStatus = void 0;
var ReceiptStatus;
(function (ReceiptStatus) {
    ReceiptStatus["Created"] = "Created";
    ReceiptStatus["Canceled"] = "Canceled";
    ReceiptStatus["Pending"] = "Pending";
})(ReceiptStatus || (exports.ReceiptStatus = ReceiptStatus = {}));
